module.exports = __webpack_public_path__ + "Cancel-51c140ac913d1ac341f0.png";